export default {
  name: 'WeibyButton',
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
  },
};
